import { Component, inject, Input, OnInit } from '@angular/core';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { IonLabel } from '@ionic/angular/standalone';
import { ModeControlMultipleComponent } from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { ModeControlSimpleComponent } from '../../../../../../../../components/ecosystems/mode-control-simple/mode-control-simple.component';

@Component({
  selector: 'app-p00080-altimeo-controle',
  templateUrl: './p00080-altimeo-controle.component.html',
  styleUrls: ['./p00080-altimeo-controle.component.scss'],
  imports: [
    IonLabel,
    ModeControlMultipleComponent,
    ModeControlSimpleComponent,
    TranslatePipe,
  ],
})
export class P00080AltimeoControleComponent implements OnInit {
  private slideModalcontroller: SlideModalController =
    inject(SlideModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
